import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/productSlider.svg?inline';
import { DynamicProductSelector } from '@/types/dynamicProducts';

export interface DynamicProductSliderComponentProps {
	readonly title?: string;
	readonly subtitle?: string;
	readonly products?: DynamicProductSelector;
	readonly count?: number;
	readonly hideArrows?: boolean;
}

const register = <TProps extends DynamicProductSliderComponentProps>(Component: React.FC<TProps>): void => {
	Builder.registerComponent(Component, {
		name: 'DynamicProductSlider',
		image,
		inputs: [
			{
				type: 'string',
				name: 'subtitle',
				defaultValue: 'Latest trends',
			},
			{
				type: 'string',
				name: 'title',
				defaultValue: 'See our new arrivals',
			},
			{
				type: 'Bizzkit ECS Dynamic Product List',
				name: 'products',
			},
			{
				type: 'number',
				name: 'count',
				helperText: 'Number of products to show',
				defaultValue: 6,
			},
			{
				name: 'hideArrows',
				type: 'boolean',
				defaultValue: false,
				friendlyName: 'Hide arrows',
			},
		],
	});
};

export default register;
